







import { Component, Prop, Vue } from 'vue-property-decorator';
import { RequestType } from 'jovo-client-web-vue';

@Component({
  name: 'embedded-chat-conversation-quick-reply',
})
export default class EmbeddedChatConversationQuickReply extends Vue {
  @Prop({ required: true, type: String })
  quickReply!: string;


// "quickReply" permet d'afficher les boutons de réponse

  async sendQuickReply() {
  // WORK AROUND HG suppression voir slack https://jovodevs.slack.com/archives/C82DKJ7T5/p1615399345075800
  const request = this.$client.createRequest({ type: RequestType.Text, body: { text: this.quickReply}});
  return request.send({body: JSON.stringify(request),});
  }
}
